export default {
    path: '/bookkeeping-offer/:id',
    component: () => import('@/components/Client/BookkeepingOffer/BookkeepingOfferView.vue'),
    name: 'bookkeeping-offer-client-details',
    meta: {
        private: true,
        dossier: 'client',
    },
};
